import { makeAutoObservable } from "mobx";
import { PTemporarilyUnavailableIngredients } from "./PTemporarilyUnavailableIngredients";
export class PSinglePartProductInstanceCreator {
    constructor(params) {
        this.type = "SinglePartCreator";
        this._commonModifierInstanceCreators =
            params.commonModifierInstanceCreators;
        this.commonCustomParameterInstanceCreators =
            params.commonCustomParameterInstanceCreators;
        this.part = params.part;
        this.productTypePackagingFeeCreator = params.productTypePackagingFeeCreator;
        makeAutoObservable(this);
    }
    get commonModifierInstanceCreators() {
        return this._commonModifierInstanceCreators.filter((m) => m.isVisible);
    }
    validate() {
        this.commonCustomParameterInstanceCreators.forEach((c) => c.creatorConfigValidation.validate());
        this.commonModifierInstanceCreators.forEach((m) => m.creatorConfigValidation.validate());
        this.part.validate();
    }
    get product() {
        return {
            name: this.part.productName,
            photo: this.part.productPhoto,
            description: this.part.productDescription,
            baseIngredients: this.part.productBaseIngredients,
            tags: this.part.productTags,
            allergens: this.part.productAllergens.rawValues(),
            freeModifierItemsCount: this.part.productFreeModifierItemsCount,
        };
    }
    get isSubmitVisible() {
        return this.part.isSubmitVisible;
    }
    get temporarilyUnavailableIngredients() {
        const common = this._commonModifierInstanceCreators
            .map((m) => m.temporarilyUnavailableIngredients)
            .reduce((prev, curr) => prev.union(curr), PTemporarilyUnavailableIngredients.empty());
        return common.union(this.part.temporarilyUnavailableIngredients);
    }
}
export class PHalvesProductInstanceCreator {
    constructor(params) {
        this.type = "HalvesCreator";
        this._commonModifierInstanceCreators =
            params.commonModifierInstanceCreators;
        this.commonCustomParameterInstanceCreators =
            params.commonCustomParameterInstanceCreators;
        this.firstHalf = params.firstHalf;
        this.secondHalf = params.secondHalf;
        this.productTypePackagingFeeCreator = params.productTypePackagingFeeCreator;
        makeAutoObservable(this);
    }
    get commonModifierInstanceCreators() {
        return this._commonModifierInstanceCreators.filter((m) => m.isVisible);
    }
    validate() {
        this.commonCustomParameterInstanceCreators.forEach((c) => c.creatorConfigValidation.validate());
        this.commonModifierInstanceCreators.forEach((m) => m.creatorConfigValidation.validate());
        this.firstHalf.validate();
        this.secondHalf.validate();
    }
    get product() {
        return {
            name: `${this.firstHalf.productName} / ${this.secondHalf.productName}`,
            photo: this.firstHalf.productPhoto,
            description: null,
            baseIngredients: null,
            tags: [],
            allergens: this.firstHalf.productAllergens
                .union(this.secondHalf.productAllergens)
                .rawValues(),
            freeModifierItemsCount: 0,
        };
    }
    get isSubmitVisible() {
        return this.firstHalf.isSubmitVisible && this.secondHalf.isSubmitVisible;
    }
    get temporarilyUnavailableIngredients() {
        const common = this._commonModifierInstanceCreators
            .map((m) => m.temporarilyUnavailableIngredients)
            .reduce((prev, curr) => prev.union(curr), PTemporarilyUnavailableIngredients.empty());
        return common
            .union(this.firstHalf.temporarilyUnavailableIngredients)
            .union(this.secondHalf.temporarilyUnavailableIngredients);
    }
}
